import { createLucideIcon } from "lucide-react";

export const Sorting4 = createLucideIcon(
    "Sorting4",
    [
        [
            "path",
            {
                d: "M11 12H21",
                key: "ilwhhb",
            },
        ],
        [
            "path",
            {
                d: "M11 16H21",
                key: "rjonaz",
            },
        ],
        [
            "path",
            {
                d: "M11 4H21",
                key: "1om0w0",
            },
        ],
        [
            "path",
            {
                d: "M11 8L21 8.00006",
                key: "2ee728",
            },
        ],
        [
            "path",
            {
                d: "M5.5 21C4.7998 21 3.4915 19.0057 3 18.5",
                key: "nkc38e",
            },
        ],
        [
            "path",
            {
                d: "M5.5 21C6.2002 21 7.5085 19.0057 8 18.5",
                key: "1yvnig",
            },
        ],
        [
            "path",
            {
                d: "M5.5 21V3",
                key: "1mc4pb",
            },
        ],
    ],
);
